import i18n from '@breward/i18n';

import { sliderStepLabel } from '../../../../../utils/intensityScale';

interface SliderFieldProps {
  label?: string;
  description?: string;
  value?: number;
  min?: number;
  max?: number;
  step?: number;
  stepsLabels?: string[];
}

const SliderField = ({
  label,
  description,
  value,
  min = 0,
  max = 10,
  step = 1,
  stepsLabels,
}: SliderFieldProps) => {
  const valueLabel = sliderStepLabel(stepsLabels, value, { min, max, step });

  return (
    <div className="flex w-full items-center justify-between gap-6 py-3">
      {/* Left: label + description */}
      <div className="min-w-0 flex-1">
        <div className="text-primary-700 dark:text-primary-200 font-sans text-base font-semibold leading-tight">
          {label}
        </div>
        {description && (
          <div className="text-content-500 dark:text-content-400 mt-1 font-sans text-sm leading-snug">
            {description}
          </div>
        )}
      </div>

      {/* Right: value badge */}
      {value !== undefined && value !== null ? (
        <div className="flex shrink-0 flex-col items-center gap-1">
          <div className="flex h-14 w-14 items-center justify-center rounded-full border-2 border-primary-400/50 bg-primary-50 dark:border-primary-600/50 dark:bg-primary-900/30 shadow-sm">
            <span className="font-header text-xl font-bold text-primary-700 dark:text-primary-300">
              {value}
            </span>
          </div>
          {valueLabel && (
            <span className="text-center text-xs font-medium text-content-500 dark:text-content-400 max-w-[64px] leading-tight">
              {valueLabel}
            </span>
          )}
        </div>
      ) : (
        <div className="flex shrink-0 flex-col items-center gap-1">
          <div className="flex h-14 w-14 items-center justify-center rounded-full border-2 border-content-200 dark:border-content-700 bg-content-50 dark:bg-content-800">
            <span className="font-sans text-sm text-content-400 dark:text-content-500">
              {i18n.t('global:shared.na', 'N/A')}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SliderField;
